import * as React from "react";

interface WarningTableProps {
  disclosure: {
    received_warnings: {
      length: number;
      map: Function;
    };
  };
}

const WarningTable = (props: WarningTableProps) => {
  const { received_warnings } = props.disclosure;

  if (!received_warnings.length) {
    return <div>No warnings for this disclosure</div>;
  }

  return (
    <table
      style={{ marginBottom: 0 }}
      className="table table-striped table-hover"
    >
      <thead>
        <tr>
          <th className="col-sm-1" />
          <th>Warning</th>
        </tr>
      </thead>
      <tbody>
        {received_warnings.map(w => (
          <tr key={w.status_description} className="cqm-docmagic-review__row">
            <td className="text-center cqm-docmagic-review__warning">
              <i className="fa fa-warning" />
            </td>
            <td>{w.status_description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default WarningTable;
